export default (app, locator) => {
  if (!locator) return

  const globalProperties = app.config.globalProperties
  globalProperties.$locator = locator
  globalProperties.$proxy = locator.proxy
  globalProperties.$storeFactory = locator.storeFactory
}
